const EXPLORER_VIEW_CONTAINER_ID = 'explorer-view-container';
const FILE_NAVIGATOR_ID = 'files';

type ViewContainerLike = {
    setTitleOptions(options: unknown): void;
    addWidget(widget: unknown, options: unknown): void;
};

type NavigatorWidgetFactoryLike = {
    viewContainerFactory(options: { id: string; progressLocationId: string }): ViewContainerLike;
    widgetManager: {
        getOrCreateWidget(id: string): Promise<unknown>;
    };
    fileNavigatorWidgetOptions: unknown;
};

let navigatorWidgetFactoryPatched = false;

export function disableNavigatorOpenEditorsWidget(): void {
    if (navigatorWidgetFactoryPatched) return;

    try {
        const module = require('@theia/navigator/lib/browser/navigator-widget-factory') as {
            EXPLORER_VIEW_CONTAINER_TITLE_OPTIONS?: unknown;
            NavigatorWidgetFactory?: { prototype?: Record<string, unknown> };
        };
        const prototype = module.NavigatorWidgetFactory?.prototype;
        if (!prototype || !module.EXPLORER_VIEW_CONTAINER_TITLE_OPTIONS) return;

        prototype.createWidget = async function patchedCreateWidget(
            this: NavigatorWidgetFactoryLike
        ): Promise<ViewContainerLike> {
            const viewContainer = this.viewContainerFactory({
                id: EXPLORER_VIEW_CONTAINER_ID,
                progressLocationId: 'explorer'
            });
            viewContainer.setTitleOptions(module.EXPLORER_VIEW_CONTAINER_TITLE_OPTIONS);

            const navigatorWidget = await this.widgetManager.getOrCreateWidget(FILE_NAVIGATOR_ID);
            viewContainer.addWidget(navigatorWidget, this.fileNavigatorWidgetOptions);
            return viewContainer;
        };

        navigatorWidgetFactoryPatched = true;
    } catch {
        // No-op: this keeps startup resilient if module resolution changes.
    }
}
